import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { getSitesByParentGroupAlerts } from "./AlertsUtils/getSitesByParentGroupAlerts";
import { getRefreshTimeout } from "../../utils/getRefreshTimeout";
import { alertsFilterMultiSelectSx } from "./AlertsUtils/alertsFilterBar";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";
import {
  buildScopePickerOptions,
  ScopeGroup,
  ScopePickerOption,
} from "./AlertsUtils/alertScope";

export const ParentGroupsDropDownAlertsPage = ({
  userFilters,
  setUserFilters,
  navigate,
  setSiteOptions,
  setSiteDropDownValue,
  setCameraOptions,
  setCameraDropDownValue,
  setLoadingSites,
  setRefreshInterval,
  parentAccounts,
  parentIds,
  parentAccountsLoading,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  navigate: NavigateFunction;
  setSiteOptions: Dispatcher<any>;
  setCameraOptions: Dispatcher<any>;
  setSiteDropDownValue: Dispatcher<string[]>;
  setCameraDropDownValue: Dispatcher<string[]>;
  setLoadingSites: Dispatcher<boolean>;
  setRefreshInterval: any;
  parentAccounts: any;
  parentIds: any;
  parentAccountsLoading: boolean;
  navBarCollapsed: boolean;
}) => {
  const { flags } = useFeatureFlag();
  const showAlertsScopeContext = Boolean(flags.showAlertsScopeContext);
  const parentAccountsData = JSON.parse(localStorage?.parentAccounts || "[]");
  const liveAccounts: ScopeGroup[] =
    Array.isArray(parentAccounts) && parentAccounts.length > 0
      ? parentAccounts
      : parentAccountsData;

  const parentNamesMap = new Map();
  parentAccountsData.forEach((object: any) => {
    parentNamesMap.set(object.id, object.name);
  });

  const flatOptions: ScopePickerOption[] = parentAccountsData[0]
    ? parentAccountsData.map((object: any) => ({
        id: object.id,
        name: object.name,
        depth: 0,
        path: object.name,
        siteCount: null,
        parentId: null,
      }))
    : [];
  const options = showAlertsScopeContext
    ? buildScopePickerOptions(liveAccounts)
    : flatOptions;
  const selectedId = userFilters.parent_group
    ? Number(userFilters.parent_group)
    : null;
  const selectedOption =
    selectedId == null
      ? null
      : options.find((option) => option.id === selectedId) ?? {
          id: selectedId,
          name: parentNamesMap.get(selectedId) || "",
          depth: 0,
          path: parentNamesMap.get(selectedId) || "",
          siteCount: null,
          parentId: null,
        };

  return (
    <div key="parent_groups_dropdown" className="w-full">
      <Autocomplete
        disablePortal
        options={options}
        getOptionLabel={(option) =>
          (showAlertsScopeContext ? option.path : option.name) || ""
        }
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={selectedOption}
        loading={parentAccountsLoading}
        onChange={(event, value: any) => {
          setRefreshInterval(getRefreshTimeout(value?.id));
          setSiteOptions([]);
          setCameraOptions([]);
          setSiteDropDownValue([]);
          setCameraDropDownValue([]);
          if (value !== null) {
            getSitesByParentGroupAlerts(
              value.id,
              navigate,
              setSiteOptions,
              setLoadingSites
            );
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                parent_group: value.id,
                site: "",
                camera: "",
              };
            });
          } else {
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                parent_group: "",
                site: "",
                camera: "",
              };
            });
          }
        }}
        sx={alertsFilterMultiSelectSx}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Parent Group"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {parentAccountsLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li
            {...props}
            key={option.id}
            style={{
              ...props.style,
              paddingLeft: showAlertsScopeContext
                ? 16 + option.depth * 16
                : props.style?.paddingLeft,
            }}
          >
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
